import {
    IChangedSetting,
} from '../settingsChangeServiceContract';

export class ChangedSetting implements IChangedSetting {
    public key: string;
    public value: any;

    constructor(key: string, value: any) {
        this.key = key;
        this.value = value;
    }
}
